// extracted by mini-css-extract-plugin
module.exports = {"loader":"SearchNoResults_loader__9u64y","loading-button":"SearchNoResults_loading-button__YE911"};